import Vue from "vue";
import Vuex from "vuex";
import Base from "./modules/base";
import Auth from "./modules/auth";
import Card from "./modules/card";
import OTP from "./modules/otp";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    Base,
    Auth,
    Card,
    OTP,
  },
});
